module.exports = __webpack_public_path__ + "images/33da44e78c6b881e19ae1095f0b71bcf-Roboto-LightItalic.svg";